<div class="d-flex flex-column h-100">
	<div class="row">
		<mat-form-field class="col">
			<input
				matInput
				(keyup)="setSearchString($event.target.value)"
				placeholder="{{ 'mep.components.edit-project-access-dialog.filter' | translate }}"
				autocomplete="off"
			/>
		</mat-form-field>

		<h2 class="col">{{ "mep.components.edit-project-access-dialog.grant_access_to" | translate }}</h2>
	</div>
	<div class="row flex-grow-1 overflow-hidden" cdkDropListGroup>
		<div class="col h-100 pt-3 pb-3">
			<div class="mat-elevation-z8 table-container">
				<mat-progress-bar mode="indeterminate" [hidden]="!loading"></mat-progress-bar>
				<mat-table
					#leftTable
					mat-table
					[dataSource]="leftDataSource"
					cdkDropList
					[cdkDropListData]="leftDataSource.data"
					cdkDropListSortingDisabled
					(cdkDropListDropped)="drop($event, getPaginatorOffset(leftPaginator), getPaginatorOffset(rightPaginator))"
				>
					<ng-container matColumnDef="name">
						<mat-header-cell *matHeaderCellDef>
							{{ "mep.components.edit-project-access-dialog.name" | translate }}
						</mat-header-cell>
						<mat-cell *matCellDef="let row">
							{{ row.lastName + ", " + row.firstName + ", " + row.personnelNumber }}
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="action">
						<mat-header-cell *matHeaderCellDef></mat-header-cell>
						<mat-cell *matCellDef="let row">
							<button mat-icon-button (click)="leftToRight(row)">
								<mat-icon>{{ isInRightTable(row) ? "" : "person_add" }}</mat-icon>
							</button>
						</mat-cell>
					</ng-container>
					<mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag class="draggable"></mat-row>
				</mat-table>

				@if (leftDataSource.data.length === 0) {
					<div class="text-center pt-2">
						{{ "mep.components.edit-project-access-dialog.filter-for-employees-message" | translate }}
					</div>
				}

				<mat-paginator
					#leftPaginator
					[pageSizeOptions]="[5, 10, 25, leftDataSource.filteredData.length]"
				></mat-paginator>
			</div>
		</div>

		<div class="col h-100 pt-3 pb-3">
			<div class="mat-elevation-z8 table-container">
				<mat-table
					#rightTable
					[dataSource]="rightDataSource"
					cdkDropList
					[cdkDropListData]="rightDataSource.data"
					cdkDropListSortingDisabled
					(cdkDropListDropped)="drop($event, getPaginatorOffset(rightPaginator), getPaginatorOffset(leftPaginator))"
				>
					<ng-container matColumnDef="name">
						<mat-header-cell *matHeaderCellDef>
							{{ "mep.components.edit-project-access-dialog.name" | translate }}
						</mat-header-cell>
						<mat-cell *matCellDef="let row">
							{{ row.lastName + ", " + row.firstName + ", " + row.personnelNumber }}
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="action">
						<mat-header-cell *matHeaderCellDef></mat-header-cell>
						<mat-cell *matCellDef="let row">
							@if (row.id !== projectLeader) {
								<button mat-icon-button (click)="rightToLeft(row)">
									<mat-icon>remove_circle_outline</mat-icon>
								</button>
							}
						</mat-cell>
					</ng-container>
					<mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag class="draggable"></mat-row>
				</mat-table>
				<mat-paginator
					#rightPaginator
					[pageSizeOptions]="[5, 10, 25, rightDataSource.filteredData.length]"
				></mat-paginator>
			</div>
		</div>
	</div>
</div>
